import { Spacing, Text, Title } from '@vkontakte/vkui';
import React from 'react';
import { Button, ButtonSizeMode } from 'reactApp/ui/Button/Button';
import { MobileDialog } from 'reactApp/ui/Mobile/MobileDialog/MobileDialog';
import { LegalBlock } from 'reactApp/ui/SummerCampaign2026Modal/LegalBlock/LegalBlock';
import { type TouchTariffConfig, ImageStates } from 'reactApp/ui/SummerCampaign2026Modal/SummerCampaign2026Modal.types';

import styles from './SummerCampaign2026ModalMobile.css';

export interface SummerCampaign2026ModalMobileProps {
    onClose?: () => void;
    title: string;
    text: string;
    primaryButtonText: string;
    secondaryButtonText: string;
    imageState: ImageStates;
    config: TouchTariffConfig;
    erid: string;
    onShow?: () => void;
    onPrimaryClick: () => void;
    onSecondaryClick: () => void;
}

export const SummerCampaign2026ModalMobile: React.FC<SummerCampaign2026ModalMobileProps> = ({
    onClose,
    title,
    text,
    primaryButtonText,
    secondaryButtonText,
    imageState,
    config,
    erid,
    onShow,
    onPrimaryClick,
    onSecondaryClick,
}) => {
    const scrollRef = React.useRef<HTMLDivElement>(null);

    const handleClose = (_e?: React.MouseEvent) => {
        onClose?.();
    };

    return (
        <MobileDialog
            id="summer-campaign-2026"
            onClose={handleClose}
            closable={false}
            closeOnDimmerClick
            topmost
            scrollRef={scrollRef}
            mod="base"
            contextPadding="zero"
            className={styles.root}
            onShow={onShow}
        >
            <div className={styles.imageWrapper}>
                {imageState === ImageStates.inProgress && (
                    <video autoPlay muted playsInline className={styles.animation}>
                        <source src={config.animation} type="video/webm" />
                    </video>
                )}
                <img className={styles.image} src={imageState === ImageStates.end ? config.endImg : config.startImg} alt="Летняя акция" />
                <LegalBlock erid={erid} isMobile />
            </div>
            <div ref={scrollRef} className={styles.textBlock}>
                <Title level="2" className={styles.title}>
                    {title}
                </Title>
                <Spacing size={8} />
                <Text className={styles.text}>{text}</Text>
                <Spacing size={32} />
                <Button theme="vk" primary sizeMode={ButtonSizeMode.extraBig} onClick={onPrimaryClick}>
                    {primaryButtonText}
                </Button>
                <Spacing size={8} />
                <Button theme="vk" className={styles.secondary} sizeMode={ButtonSizeMode.extraBig} onClick={onSecondaryClick}>
                    {secondaryButtonText}
                </Button>
            </div>
        </MobileDialog>
    );
};

export default SummerCampaign2026ModalMobile;
